import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Input,
  Button,
  Select,
  Message,
  Card,
  Table,
  NumberPicker,
  DatePicker,
  Radio,
} from '@alifd/next';
import { Form } from 'antd';
import axios from 'axios';
import moment from 'moment';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;
const Option = Select.Option;
const RepairBudgetList = () => {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const communityDevice = client.service('communityDevice');
  const annualFixBudget = client.service('annualFixBudget');
  const [communityDeviceDialog, setCommunityDeviceDialog] = useState(false);
  const [communityDeviceArr, setCommunityDeviceArr] = useState([]);
  const [communityDeviceUpdate, setCommunityDeviceUpdate] = useState({});
  const [communityDeviceStatus, setCommunityDeviceStatus] = useState('insert');
  const [isUpdate, setIsUpdate] = useState(false);
  const [annualFixBudgetArr, setAnnualFixBudgetArr] = useState([]);
  const [annualFixBudgetDialog, setAnnualFixBudgetDialog] = useState(false);
  const [
    annualFixBudgetRecordDialog,
    setAnnualFixBudgetRecordDialog,
  ] = useState(false);

  useEffect(() => {
    communityDevice
      .find({ query: {} })
      .then((result) => {
        setCommunityDeviceArr(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        '/ezcon/api/postMongoAggregate',
        {
          aggregate: [
            {
              $addFields: {
                deviceId: { $toObjectId: '$deviceId' },
              },
            },
            {
              $lookup: {
                from: 'communityDevice',
                localField: 'deviceId',
                foreignField: '_id',
                as: 'communityDevice',
              },
            },
            {
              $match: {
                isLong: false,
              },
            },
          ],
          service: 'annualFixBudget',
        },
        {
          headers: {
            authorization: localStorage.getItem('feathers-jwt'),
          },
        }
      )
      .then((result) => {
        setAnnualFixBudgetArr(result.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [isUpdate, communityDevice]);

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 20,
      },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 20,
        offset: 4,
      },
    },
  };

  const onFinish = (value) => {
    const newDeviceObject = {
      deviceId: value.deviceId,
      repairNum: value.repairNum,
      repairExpenses: parseInt(value.repairExpenses, 10),
      repairBalance: parseInt(value.repairExpenses, 10),
      repairRecords: [],
      repairStartYear: moment(value.repairStartYear[0]).valueOf(),
      repairEndYear: moment(value.repairStartYear[1]).valueOf(),
      isLong: false,
    };
    if (communityDeviceStatus === 'insert') {
      annualFixBudget
        .create(newDeviceObject)
        .then(() => {
          Message.success('新增成功');
          setCommunityDeviceDialog(false);
          setIsUpdate((pre) => !pre);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      annualFixBudget
        .patch(communityDeviceUpdate._id, newDeviceObject)
        .then(() => {
          Message.success('修改成功');
          setCommunityDeviceDialog(false);
          setIsUpdate((pre) => !pre);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const onFinishRecord = (value) => {
    const newRecordObject = [
      ...communityDeviceUpdate.repairRecords,
      {
        ...value,
        createdTime: moment().valueOf(),
      },
    ];
    annualFixBudget
      .patch(communityDeviceUpdate._id, {
        repairRecords: newRecordObject,
        repairBalance: parseInt(
          communityDeviceUpdate.repairBalance - value.repairRecordMoney,
          10
        ),
      })
      .then(() => {
        Message.success('新增修繕記錄成功');
        setIsUpdate((pre) => !pre);
        setAnnualFixBudgetRecordDialog(false);
        annualFixBudget
          .find({ query: { _id: communityDeviceUpdate._id } })
          .then((result) => {
            setCommunityDeviceUpdate(result.data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Button
        onClick={() => {
          setCommunityDeviceUpdate({});
          setCommunityDeviceDialog(true);
          setCommunityDeviceStatus('insert');
        }}
      >
        新增
      </Button>

      {/* 新增修改年度修繕預算 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={communityDeviceDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          setCommunityDeviceDialog(false);
        }}
        onClose={() => {
          setCommunityDeviceDialog(false);
        }}
      >
        <h1>
          {communityDeviceStatus === 'insert' ? '新增' : '修改'}緊急修繕記錄
        </h1>

        <Form
          form={form}
          name="dynamic_form_item"
          onFinish={onFinish}
          {...formItemLayoutWithOutLabel}
          initialValues={
            communityDeviceUpdate?.deviceId
              ? {
                  deviceId: communityDeviceUpdate.deviceId,
                  repairNum: communityDeviceUpdate.repairNum,
                  repairExpenses: communityDeviceUpdate.repairExpenses,
                  repairStartYear: [
                    moment(communityDeviceUpdate.repairStartYear),
                    moment(communityDeviceUpdate.repairEndYear),
                  ],
                }
              : { repairNum: 1 }
          }
        >
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇設備名稱',
              },
            ]}
            label="設備名稱"
            name="deviceId"
          >
            <Select
              className={styles.options}
              placeholder="請選擇設備名稱"
              aria-label="name is"
            >
              {communityDeviceArr.map((item) => (
                <Option value={item._id} key={item._id}>
                  {item.deviceName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="預計修繕次數"
            name="repairNum"
            rules={[
              {
                required: true,
                message: '請輸入預計修繕次數',
              },
            ]}
            {...formItemLayout}
          >
            <NumberPicker min={1} />
          </Form.Item>
          <Form.Item
            label="預計修繕總費用"
            name="repairExpenses"
            rules={[
              {
                required: true,
                message: '請輸入預計修繕總費用',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="修繕年度"
            name="repairStartYear"
            rules={[
              {
                required: true,
                message: '請選擇修繕年度',
              },
            ]}
            {...formItemLayout}
          >
            <RangePicker type="year" />
          </Form.Item>
        </Form>
      </Dialog>

      {/* 查看維修記錄 */}

      <Dialog
        hasMask
        className={styles.dialog}
        visible={annualFixBudgetDialog}
        onOk={() => {
          setAnnualFixBudgetDialog(false);
        }}
        onCancel={() => {
          setAnnualFixBudgetDialog(false);
        }}
        onClose={() => {
          setAnnualFixBudgetDialog(false);
        }}
      >
        <h1>查看緊急修繕記錄</h1>
        <Button
          type="normal"
          onClick={() => setAnnualFixBudgetRecordDialog(true)}
          style={{ marginBottom: '20px' }}
        >
          新增修繕記錄
        </Button>
        <Table dataSource={communityDeviceUpdate.repairRecords}>
          <Table.Column
            dataIndex="createdTime"
            title="維修時間"
            cell={(value) => moment(value).format('YYYY-MM-DD')}
          />
          <Table.Column dataIndex="repairRecordStatus" title="修繕狀態" />
          <Table.Column dataIndex="repairRecordText" title="修繕記錄" />
          <Table.Column dataIndex="repairRecordMoney" title="修繕金額" />
          <Table.Column dataIndex="repairRecordPerson" title="修繕人員" />
        </Table>
      </Dialog>

      {/* 新增編輯維修記錄 */}
      <Dialog
        name="dynamic_form_item"
        hasMask
        className={styles.dialog}
        visible={annualFixBudgetRecordDialog}
        onOk={() => {
          form1.submit();
        }}
        onCancel={() => {
          setAnnualFixBudgetRecordDialog(false);
        }}
        onClose={() => {
          setAnnualFixBudgetRecordDialog(false);
        }}
      >
        <h1>新增修繕記錄</h1>
        <Form
          form={form1}
          onFinish={onFinishRecord}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            label="設備狀態"
            name="repairRecordStatus"
            rules={[
              {
                required: true,
                message: '請選擇維修狀態',
              },
            ]}
            {...formItemLayout}
          >
            <RadioGroup aria-labelledby="groupId">
              <Radio value="處理中">處理中</Radio>
              <Radio value="已處理">已處理</Radio>
            </RadioGroup>
          </Form.Item>
          <Form.Item
            label="修繕記錄"
            name="repairRecordText"
            rules={[
              {
                required: false,
                message: '請輸入修繕記錄',
              },
            ]}
            {...formItemLayout}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="修繕金額"
            name="repairRecordMoney"
            rules={[
              {
                required: true,
                message: '請輸入修繕單次費用',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="修繕人員"
            name="repairRecordPerson"
            rules={[
              {
                required: true,
                message: '請輸入修繕人員',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
        </Form>
      </Dialog>

      <br />
      <br />
      <Card free>
        <Card.Content>
          <Table dataSource={annualFixBudgetArr}>
            <Table.Column
              title="設備名稱"
              width={150}
              cell={(_value, _index, record) => (
                <div>{record.communityDevice[0].deviceName}</div>
              )}
            />
            <Table.Column
              title="設備編號"
              width={150}
              cell={(_value, _index, record) => (
                <div>{record.communityDevice[0].deviceNumber}</div>
              )}
            />
            <Table.Column
              title="維護廠商"
              width={100}
              cell={(_value, _index, record) => (
                <div>{record.communityDevice[0].deviceVendor[0].name}</div>
              )}
            />
            <Table.Column
              title="修繕合約期間"
              width={100}
              cell={(_value, _index, record) =>
                `${moment(record.repairStartYear).format('YYYY')}年至${moment(
                  record.repairEndYear
                ).format('YYYY')}年`
              }
            />
            <Table.Column
              title="預計修繕次數"
              width={100}
              dataIndex="repairNum"
              cell={(value) => `${value}次`}
            />
            <Table.Column
              title="預計修繕總金額"
              width={100}
              dataIndex="repairExpenses"
              cell={(value) => `${value}元`}
            />
            <Table.Column
              title="目前剩餘金額"
              width={100}
              dataIndex="repairBalance"
              cell={(value) => `${value}元`}
            />
            <Table.Column
              title="操作"
              width={100}
              cell={(_value, _index, record) => {
                if (record.repairRecords.length === 0) {
                  return (
                    <div className={styles.btnGroup}>
                      <Button
                        type="primary"
                        onClick={() => {
                          setCommunityDeviceUpdate(record);
                          setAnnualFixBudgetDialog(true);
                        }}
                      >
                        查看緊急修繕記錄
                      </Button>

                      <Button
                        type="normal"
                        onClick={() => {
                          setCommunityDeviceStatus('update');
                          setCommunityDeviceUpdate(record);
                          setCommunityDeviceDialog(true);
                        }}
                      >
                        編輯
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => {
                          annualFixBudget
                            .remove(record._id)
                            .then(() => {
                              Message.success('刪除成功');
                              setIsUpdate((pre) => !pre);
                            })
                            .catch((error) => console.log(error));
                        }}
                        warning
                      >
                        刪除
                      </Button>
                    </div>
                  );
                } else {
                  return (
                    <div className={styles.btnGroup}>
                      <Button
                        type="primary"
                        onClick={() => {
                          setCommunityDeviceUpdate(record);
                          setAnnualFixBudgetDialog(true);
                        }}
                      >
                        查看緊急修繕記錄
                      </Button>
                    </div>
                  );
                }
              }}
            />
          </Table>
        </Card.Content>
      </Card>
    </>
  );
};

export default RepairBudgetList;
